export const getAdyenConfiguration = (
  adyenClientEnv,
  clientKey,
  locale = "en_US",
  handleOnChange
) => {
  return {
    environment: adyenClientEnv,
    locale: locale,
    clientKey: clientKey,
    showPayButton: false,
    analytics: {
      enabled: true,
    },
    onChange: handleOnChange,
    onPaymentCompleted: (result, component) => {
      console.info(result, component);
    },
    onError: (error, component) => {
      console.error(error.name, error.message, error.stack, component);
    },
  };
};
